/**
 * VarianceStatusBadge
 *
 * Renders one of: On-Track, Over-Budget, Under-Budget, Unscheduled, No-Show.
 */

/** @typedef {'on_track'|'over_budget'|'under_budget'|'unscheduled'|'no_show'} VarianceStatus */

const STATUS_CONFIG = /** @type {Record<VarianceStatus, { label: string, classes: string }>} */ ({
  on_track: { label: 'On-Track', classes: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  over_budget: { label: 'Over-Budget', classes: 'bg-amber-500/15 text-amber-400 border-amber-500/30' },
  under_budget: { label: 'Under-Budget', classes: 'bg-sky-500/15 text-sky-400 border-sky-500/30' },
  unscheduled: { label: 'Unscheduled', classes: 'bg-rose-500/15 text-rose-400 border-rose-500/30' },
  no_show: { label: 'No-Show', classes: 'bg-muted/15 text-secondary border-muted/30' },
});

/** @param {{ status: VarianceStatus }} props */
export const VarianceStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.on_track;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${config.classes}`}
    >
      {config.label}
    </span>
  );
};
